import { AutoCompleteOption } from "../common/AutoComplete";
import DamageFormService from "./service/DamageFormService";

interface MasterDataDamageEntry {
  id: number,
  code: string,
  descr: string,
}

export const getAllRepository = (tenantValue:any): Promise<MasterDataDamageEntry[]> => {
  return DamageFormService.list.getRepository(tenantValue)
}

export const getAllEvent = (tenantValue:any, fromSearch: string = ""): Promise<MasterDataDamageEntry[]> => {
  return DamageFormService.list.getEvent(tenantValue, fromSearch)
}

export const getAllEventType = (tenantValue:any): Promise<MasterDataDamageEntry[]> => {
  return DamageFormService.list.getEventType(tenantValue)
}

export const getAllMS = (tenantValue:any): Promise<AutoCompleteOption[]> => {
  return DamageFormService.list.getMobilityStore(tenantValue).then(response => response.map((res:any) => ({ tenant: `${res.tenant}`,  label: `${res.label}`, value: `${res.sapId}` })),
  )
}